'use strict';

/**
 *
 * @name: playersAnalytics
 *
 */

function PlayersAnalyticsFactory($analytics, $rootScope, $location, $state) {

  'ngInject';

  function pV() {

    var properties = {
      eventAction: $location.path(),
      eventPoints: 0,
      attributes: {
        label: $rootScope.post.translations[$rootScope.lang].title
      }
    };

    return $analytics.eventTrack('Persistent Video', properties);
  }

  function socialShare(network) {

    var properties = {
      eventAction: 'Share | ' + network,
      eventPoints: 0,
      attributes: {
        label: $rootScope.post.translations[$rootScope.lang].title
      }
    };

    return $analytics.eventTrack('Video Interactions', properties);
  }

  function socialShareMobile(network) {

    var properties = {
      eventAction: 'Share | ' + network,
      eventPoints: 0,
      attributes: {
        label: $rootScope.post.translations[$rootScope.lang].title
      }
    };

    return $analytics.eventTrack('Sticky mobile strip', properties);
  }

  function drawerAction(action) {

    var properties = {
      eventAction: 'Show',
      eventPoints: 0,
      attributes: {
        label: action
      }
    };

    var eventName = 'Drawer Interactions';

    return $analytics.eventTrack(eventName, properties);
  }

  function videoAction(action) {

    var properties = {
      eventAction: action,
      eventPoints: 0,
      attributes: {
        label: $rootScope.post.translations[$rootScope.lang].title
      }
    };

    var eventName = 'Video Interactions';

    if (action === 'Rating') {

      if ($state.current.name === 'main.seriesSingle') {

        if ($rootScope.post.series.translations.hasOwnProperty('en-us')) {

          properties.eventAction = 'Series page | ' + $rootScope.post.series.translations[$rootScope.lang].title;
        } else {

          properties.eventAction = 'Series page | ' + $rootScope.post.series.translations[0].title;
        }

        properties.attributes.label = $location.path();
        eventName = 'Rating';
      } else if ($state.current.name === 'main.story') {

        properties.eventAction = 'Article | ' + $rootScope.post.translations[$rootScope.lang].title;
        properties.attributes.label = $location.path();
        eventName = 'Rating';
      }
    }

    return $analytics.eventTrack(eventName, properties);
  }

  return {
    pV: pV,
    socialShareMobile: socialShareMobile,
    socialShare: socialShare,
    drawerAction: drawerAction,
    videoAction: videoAction
  };
}

export default PlayersAnalyticsFactory;



// WEBPACK FOOTER //
// ./app/components/nn-players/nn-players-analytics.factory.js